import http from './http'

export default {
  getAll () {
    return http.get('/shops')
  },
  getByOwner (userId) {
    return http.get(`/shops/owner/${userId}`)
  },
  getById (shopId) {
    return http.get(`/shops/${shopId}`)
  },
  create (payload) {
    return http.post('/shops', payload)
  },
  update (shopId, payload) {
    return http.put(`/shops/${shopId}`, payload)
  },
  getStylists (shopId) {
    return http.get(`/shops/${shopId}/stylists`)
  },
  getBookingSlots (shopId, date) {
    return http.get(`/shops/${shopId}/booking-slots`, { params: { date } })
  },
  createBookingSlot (shopId, payload) {
    return http.post(`/bookings/admin/${shopId}/booking-slots`, payload)
  },
  updateBookingSlot (shopId, slotId, payload) {
    return http.put(`/bookings/admin/${shopId}/booking-slots/${slotId}`, payload)
  },
  deleteBookingSlot (shopId, slotId) {
    return http.delete(`/bookings/admin/${shopId}/booking-slots/${slotId}`)
  },
  toggleVisibility (shopId, payload) {
    return http.patch(`/shops/${shopId}/visibility`, payload)
  },
  updateBookingPolicy (shopId, payload) {
    return http.patch(`/shops/${shopId}/booking-policy`, payload)
  },
  remove (shopId) {
    return http.delete(`/shops/${shopId}`)
  },
  restore (shopId) {
    return http.post(`/shops/${shopId}/restore`)
  }
}
